import * as React from 'react';

import styled from 'styled-components';
import * as grid from 'view/styles/grid';
import { LoadingContainer } from '@atlassian/help-center-common-component/loading-container';

interface NoteContentProps {
    isLoading: boolean;
    isCentered?: boolean;
    children: React.ReactNode;
}

export class NoteContent extends React.Component<NoteContentProps> {
    render() {
        return (
            <NoteContentContainer isCentered={this.props.isCentered} data-testid="note-content-container">
                <LoadingContainer isLoading={this.props.isLoading} loadingPosition="fill-container">
                    {this.props.children}
                </LoadingContainer>
            </NoteContentContainer>
        );
    }
}

interface NoteContentContainerProps {
    isCentered?: boolean;
}

const spacing = grid.multiple(8).px;

const NoteContentContainer = styled.div<NoteContentContainerProps>`
    margin: ${spacing};
    max-width: ${grid.multiple(44).px};
    text-align: ${(props) => (props.isCentered ? 'center' : 'start')};
`;
